module.exports = __webpack_public_path__ + "static/elliot-craig-a155fc629d367fb0ee95ee8a7b2cba88.mp4";